<template>
    <div>
        <ticket-filter :action="filterAction" ></ticket-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable" id="datatable"></kt-datatable>
    </div>
</template>

<script>
import ticketFilter from '@/views/ticket/components/ticket-filter'
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "@/views/ticket/datatable/columns";
import actions from "@/views/ticket/datatable/actions";
import commonAccessColumns from "@/views/ticket/datatable/commonAccessColumns";
import {mapGetters} from "vuex";

export default {
    components: {
        ticketFilter
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {
                knowledge_cat_id: this.$route.params.hashid
            }
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "tickets",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('ticket/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions
            }
        },
        ...mapGetters('ticket', [
            'status'
        ]),
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    },
    mounted() {
        this.$store.dispatch('ticket/fetchCategories')
    }
}
</script>